export * from './hotkeys.model';
export * from './hotkeys.component';
